import React, { useEffect, useState } from 'react';
import { Collapse, Spin } from 'antd';

import './notifications.less';
import { useTranslation } from 'react-i18next';
import { isArray } from '@craco/craco/lib/utils';
import { checkingForOnlyErrorNotification } from '../../utils/utilFuntions';
import moment from 'moment';
import { Box, Divider } from '@mui/material';
import { GetNotificationsPaginData } from './API/action';

const { Panel } = Collapse;

const Notifications = () => {
  const { t } = useTranslation();

  const [notificationsData, setNotificationsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    const params = new URLSearchParams();
    params.append('f', 'id$gte$0');
    params.append('o', 'sent_time$desc');
    params.append('page', currentPage);
    params.append('page_size', 10);

    setLoading(true);
    let { data, error, message } = await GetNotificationsPaginData(params);
    setLoading(false);
    if (!error) setNotificationsData(data);
    checkingForOnlyErrorNotification(error, message);
  };

  useEffect(() => {
    fetchNotifications();
  }, [currentPage]);

  const pageIncrementHandler = () => {
    if (notificationsData.length == 10 && !loading) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const pageDecrementHandler = () => {
    if (currentPage > 1 && !loading) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <Box sx={{ px: '5rem' }}>
      <div
        className='inventory-view-content'
        style={{ width: '100%', padding: '0 1rem' }}
      >
        <div className='title'>
          <h2 className='text'>Notifications</h2>
        </div>
        {!loading && (
          <div
            className={'paginationContainer'}
            style={{ margin: '.1rem' }}
          >
            <div
              className={'nextBtn'}
              onClick={() => {
                pageDecrementHandler();
              }}
            >
              {t('prev')}
            </div>
            <div
              className={'pageNumber'}
              style={{ margin: '0px 7px' }}
            >
              {currentPage}
            </div>
            <div
              className={'nextBtn'}
              onClick={() => {
                pageIncrementHandler();
              }}
            >
              {t('next')}
            </div>
          </div>
        )}
        <Divider sx={{ m: '2rem' }} />
        {loading ? (
          <Spin spinning={true}>
            <div style={{ width: '100%', height: '100%' }} />
          </Spin>
        ) : (
          <Collapse>
            {notificationsData.map((val, i) => {
              return (
                <Panel
                  className='notification-panel'
                  header={`${val.notification_title} - ${moment(
                    val.sent_time,
                  ).format('MMM DD, h.mm A')}`}
                  key={i}
                >
                  <div className='notification-content-change'>
                    {isArray(val.image_url_list) &&
                      val.image_url_list.length > 0 && (
                        <img
                          src={`${val.image_url_list[0]}`}
                          alt=''
                          className='notification-image'
                        />
                      )}
                    <p
                      style={{
                        textAlign: 'center',
                        marginTop: '.8rem',
                      }}
                    >
                      {val.notification_body}
                    </p>
                  </div>
                </Panel>
              );
            })}
          </Collapse>
        )}
      </div>

      <div id='bottom-padding'></div>
    </Box>
  );
};

export default Notifications;
